import { ResourceView } from '@nexelem/graphne-api';
import { parseName } from '@nexelem/utils';
import { GanttShowOnTaskOptions } from '../components/SettingsDrawer';
import { formatRequiredWorkers } from './formatRequiredWorkers';
import { AvatarItem } from '../../../molecules/MultipleTableAvatar';

type GanttUnassignedProps = {
  mode: 'default' | 'worker';
  softResourceAssignments?: ResourceView[];
  requiredSoftResourcesAmount?: number;
  showOnTask: GanttShowOnTaskOptions;
};

export const getGanttUnassigned = ({
  mode,
  softResourceAssignments = [],
  requiredSoftResourcesAmount = 0,
  showOnTask,
}: GanttUnassignedProps) => {
  const isWorkerView = mode === 'worker';

  const showAssignedWorkers = isWorkerView ? true : showOnTask.assignedWorkers;

  const hasAssignedWorkers = !!softResourceAssignments.length && showAssignedWorkers;

  // For values < 1.0, formatRequiredWorkers returns null, show 1 avatar (worker needed partially)
  // Every task requires at least some worker time, so default to 1 if null/0
  const formattedRequiredWorkers = formatRequiredWorkers(requiredSoftResourcesAmount);
  const requiredWorkersForDisplay = formattedRequiredWorkers ?? 1;

  const notEnoughSoftResources = requiredWorkersForDisplay > softResourceAssignments.length;
  const unassignedAmount =
    requiredWorkersForDisplay - softResourceAssignments.length < 0
      ? 0
      : requiredWorkersForDisplay - softResourceAssignments.length;
  const unassigned = isWorkerView && (!hasAssignedWorkers || notEnoughSoftResources);

  const avatars: AvatarItem[] = !hasAssignedWorkers
    ? new Array(requiredWorkersForDisplay).fill({})
    : [...softResourceAssignments.map(({ name }) => parseName(name)), ...new Array(unassignedAmount).fill({})];

  return { avatars, unassigned, hasAssignedWorkers };
};
